import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Divider, Typography } from '@material-ui/core';
import CheckBoxGroup from '../Select/CheckBoxGroup';
import PermissionBoxConfig from './Config/PermissionBoxConfig';
import Axios from 'axios';
import { useSnackbar } from 'notistack';

const displayTypeConst = {
   normal: 1,
   speciallistTable: 2,
};

const PermissionBox = ({ id, type, permission, refreshData }) => {
   const [checkBox, setCheckBox] = useState([
      // {
      //   label: 'เก็บคะแนน',
      //   value: 'collectPoint',
      //   checked: true,
      // },
      // {
      //   label: 'ให้คะแนน',
      //   value: 'givePoint',
      //   checked: true,
      // },
      // {
      //   label: 'แลกคะแนน',
      //   value: 'rewardRedeem',
      //   checked: true,
      // },
      // {
      //   label: 'ประวัติการใช้งาน',
      //   value: 'history',
      //   checked: true,
      // },
      // {
      //   label: 'แดชบอร์ด',
      //   value: 'dashboard',
      //   checked: true,
      // },
      // {
      //   label: 'ข้อมูลจัดส่ง',
      //   value: 'tracking',
      //   checked: true,
      // },
      // {
      //   label: 'โทรหาฝ่ายสนับสนุน',
      //   value: 'callCenter',
      //   checked: true,
      // },
   ]);
   const [isCanEdit, setIsCanEdit] = useState();
   const [displayType, setDisplayType] = useState();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   useEffect(() => {
      let temp = permission.find((el) => el.id === parseInt(id));
      if (temp) {
         setDisplayType(temp.permissionDisplayType);
         setIsCanEdit(temp.isCanEdit);
         setCheckBox(
            temp.permissionList.map((el) => {
               return {
                  permissionId: el.permissionId,
                  label: el.permissionNameTh,
                  value: el.permissionNameEn,
                  checked: el.isEnable,
               };
            }),
         );
      }
   }, [permission, id]);
   const handleCheckboxGroupChange = (updatedUseCaseCBState) => {
      setCheckBox(updatedUseCaseCBState);
      let payload = {
         permissionGroupId: id,
         permissionList: updatedUseCaseCBState.map((el) => {
            return {
               permissionId: el.permissionId,
               isEnable: el.checked,
            };
         }),
      };
      Axios.post('/GSB/dashboard/permission/EditPermissionList', payload)
         .then((resp) => {
            enqueueSnackbar('แก้ไข Permission สำเร็จ', {
               variant: 'success',
            });
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };
   const renderPermissionBox = () => {
      if (!id) {
         return <Typography>โปรดเลือกกลุ่มเพื่อจัดการสิทธิ์</Typography>;
      }
      if (displayType === displayTypeConst.speciallistTable) {
         return (
            <PermissionBoxConfig
               permission={permission.find(
                  (el) =>
                     el.permissionDisplayType ===
                     displayTypeConst.speciallistTable,
               )}
               refreshData={refreshData}
            />
         );
      }
      return (
         <Box display={'flex'} flexDirection='column' width={1}>
            <Box width={1}>
               <Box>
                  <Typography>จัดการสิทธิ์กลุ่ม {type}</Typography>
               </Box>
               <Divider />
            </Box>
            <Box display={'flex'} width={1}>
               <Box width='100%'>
                  <CheckBoxGroup
                     disabledAll={!isCanEdit}
                     title={'เลือกการใช้งานระบบหน้าบ้านทั้งหมด'}
                     checkboxes={checkBox}
                     onCheckboxGroupChange={handleCheckboxGroupChange}
                  />
               </Box>
            </Box>
         </Box>
      );
   };
   return (
      <React.Fragment>
         {displayType !== displayTypeConst.speciallistTable && (
            <React.Fragment>
               <Typography>รายการสิทธิ์ที่อนุญาต</Typography>
               <Divider />
            </React.Fragment>
         )}
         <Box>{renderPermissionBox()}</Box>
      </React.Fragment>
   );
};

export default PermissionBox;
